
    <div class="row no-gutters">
        <div class="col-12">
            <app-preview [userData]="personalArray"></app-preview>
        </div>
    </div>
    <div class="row no-gutters top_height_actionButton content_top_mobile_margin">
        <div class="col-12  d-md-block d-flex  flex-column-reverse">
            <cancel-button></cancel-button>
            <button type="button" class="common_btn saveNextBtn_features space_between_button"
                (click)="onContinue()">{{'buttonallpages.continuelable' | translate }}</button>
        </div>
    </div>
<div>
